import { concessionAttachable as conAttachable, militaryConcessionAttachable } from "../Concessions/attachable";
import { designChangeAttachable as dcAttachable, militaryDesignChangeAttachable } from "../DesignChanges/attachable";
import { doiAttachable, militaryDOIAttachable } from "../DOIs/attachable";
import { dqnAttachable, militaryDQNAttachable } from "../DQNs/attachable";
import { militarySADDAttachable, saddAttachable } from "../SADDs/attachable.js";
import { militaryServiceBulletinAttachable, serviceBulletinAttachable as sbAttachable } from "../ServiceBulletins/attachable";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import {
    editEffectivity
} from "./actions";

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Parent",
    "key": "Parent",
    "link": "Database/:ParentType/:ParentID"
}];

const menuActions = [
    {
        "label": "Edit Effectivity",
        "action": editEffectivity
    }
];

export default [{
    "path": "/Database/Effectivities",
    "component": {...ItemListView},
    "name": "Effectivities",
    "meta": {
        "app": "Database",
        "name": "Effectivities",
        "sideNav": true,
        "sideNavSection": "Misc",
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "Effectivities",
        "dataPath": "Database/Effectivities",
        "selectionRoute": "Database/Effectivities/{ID}"
    }
}, {
    "path": "/Database/Effectivities/:id",
    "component": ItemView,
    "name": "Effectivity",
    "meta": {
        "app": "Database",
        "name": "Effectivities",
        "dataPath": "Database/Effectivities",
        "selectionRoute": "Database/Effectivities/{ID}",
        title(item) {
            return `Effectivities: ${item.Number}`
        },
        "attachedItems": {
            "Items": {
                "attachables": [
                    dcAttachable, militaryDesignChangeAttachable,
                    dqnAttachable, militaryDQNAttachable,
                    conAttachable, militaryConcessionAttachable,
                    doiAttachable, militaryDOIAttachable,
                    sbAttachable, militaryServiceBulletinAttachable,
                    saddAttachable, militarySADDAttachable,
                ].filter(Boolean),
            }
        },
        "dataFields": dataFields,
        "menuActions": menuActions,
        "formMetadata": {
        "ParentType": "Effectivities",
        }
    }
}];
